import { render, staticRenderFns } from "./sendUser.vue?vue&type=template&id=01a5dec0&scoped=true&"
import script from "./sendUser.vue?vue&type=script&lang=js&"
export * from "./sendUser.vue?vue&type=script&lang=js&"
import style0 from "./sendUser.vue?vue&type=style&index=0&id=01a5dec0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a5dec0",
  null
  
)

export default component.exports